export default __webpack_public_path__ + "static/media/Hashtag Hijacking Insights - 03 - Perfect moment.f5820c76.pdf";